module.exports = __webpack_public_path__ + "img/loginbg.f60b947c.png";